
interface Props {
  className?: string;
  onClick?: Function;
  children?: string | React.ReactChild | React.ReactNode;
}

export default function Link(props: Props) {
  const { className, onClick, children } = props;

  const getClassNames = () => {
    const defaultClasses =
      "text-sm font-semibold underline font-inter cursor-pointer active:text-primaryRed hover:text-promGray2";

    if (className) {
      return `${defaultClasses} ${className}`;
    }

    return defaultClasses;
  };

  return (
    <span className={getClassNames()} onClick={() => onClick?.()}>
      {children}
    </span>
  );
}

Link.defaultProps = {
  ignoreDefaultStyle: false,
};
